
import Vue from 'vue'
import * as Api from '@/api/ContactUsApi'
import * as Analytics from '@/api/AnalyticsApi'
import { ContactUsDto } from '@ViewModels/ContactUsDto'

import { Alert } from '@/components'
import { PhoneNumber } from '@/components/display'

import FormSection from './FormSection.vue'
import ProcessingBanner from './ProcessingBanner.vue'
import EmailAddressSection from './EmailAddressSection.vue'
import SuccessSection from './SuccessSection.vue'

export default Vue.extend({
   name: 'ContactUsPage',
   data() {
      return {
         loading: true,
         submitted: false,
         processing: false,
         success: false,
         errorMessage: '',

         phoneNumber: '+64 3 211 0335',
         alternatePhoneNumber: '',
         contactEmailAddress: '',
         contactEmailAddressImage: '',
         physicalAddress: '',

         data: {
            Reason: 'Question',
            Email: '',
            School: '',
            Message: '',
            ContactNumber: '',
         } as ContactUsDto,
      }
   },
   computed: {},
   mounted() {
      this.loadModelData()
   },
   methods: {
      async loadModelData() {
         const modelData = (window as any).er
         if (modelData && modelData.contact) {
            this.phoneNumber = modelData.contact.phoneNumber
            this.alternatePhoneNumber = modelData.contact.alternatePhoneNumber
            this.contactEmailAddress = modelData.contact.contactEmailAddress
            this.contactEmailAddressImage = modelData.contact.contactEmailAddressImage
            this.physicalAddress = modelData.contact.physicalAddress
            if (modelData.contact.data) {
               this.data.School = modelData.contact.data.School
               this.data.Email = modelData.contact.data.Email
            }
         }
         this.loading = false
      },
      async sendMessage() {
         this.submitted = true
         try {
            this.processing = true
            const result = await Api.sendMessage(this.data)
            if (result.HasError) {
               this.errorMessage = result.ErrorMessage
                  ? result.ErrorMessage
                  : 'Please check your information and try again.'
               this.processing = false
            } else {
               this.processing = false
               this.success = true
               Analytics.ga4Event('contact_us', { reason: this.data.Reason })
            }
         } catch (err) {
            this.processing = false
            this.errorMessage = err.message
         }
      },
   },
   components: {
      ProcessingBanner,
      Alert,
      PhoneNumber,
      EmailAddressSection,
      SuccessSection,
      FormSection,
   },
})
